import { css } from '@emotion/react';
import {
  AlertComponent, type AlertType,
} from '~/_shared/baseComponents/alert';

const alertStyle = css({
  marginTop: 20,
});

type TwoFactorCommonComponentProps = Readonly<{
  errorMessage: string;
  isAlertOpen: boolean;
  successMessage: string;

  closeAlert: () => void;
}>;

export const TwoFactorCommonComponent: React.FC<TwoFactorCommonComponentProps> = props => {
  const alertConfig = getAlertConfig(props.successMessage, props.errorMessage);

  if (!props.isAlertOpen || !alertConfig) {
    return null;
  }

  return (
    <AlertComponent
      type={alertConfig.type}
      css={alertStyle}
      autoCloseTimeout={5000}
      onClose={props.closeAlert}
    >
      {alertConfig.message}
    </AlertComponent>
  );
};

const getAlertConfig = (
  successMessage: string, errorMessage: string
): { type: AlertType; message: string } | null => {
  if (successMessage) {
    return { type: 'success', message: successMessage };
  }
  if (errorMessage) {
    return { type: 'danger', message: errorMessage };
  }
  return null;
};
